import React, { useEffect, useId, useRef, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import "./PurchaseOrderActions.css";

export default function PurchaseOrderActions({ label, groups, disabled = false, triggerClassName = "eop-btn", captureEscape = false }) {
  const [open, setOpen] = useState(false);
  const wrapper = useRef(null);
  const trigger = useRef(null);
  const panelId = useId();
  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);
  useEffect(() => {
    if (!open) return undefined;
    const dismiss = (event) => {
      if (!wrapper.current?.contains(event.target)) setOpen(false);
    };
    const escape = (event) => {
      if (event.key !== "Escape") return;
      event.preventDefault(); event.stopImmediatePropagation(); setOpen(false); trigger.current?.focus();
    };
    document.addEventListener("pointerdown", dismiss);
    document.addEventListener("focusin", dismiss);
    if (captureEscape) window.addEventListener("keydown", escape, true);
    return () => {
      document.removeEventListener("pointerdown", dismiss);
      document.removeEventListener("focusin", dismiss);
      if (captureEscape) window.removeEventListener("keydown", escape, true);
    };
  }, [captureEscape, open]);
  return <div className="eop-orderActions" ref={wrapper} onKeyDown={(event) => {
    if (event.key === "Escape" && open) {
      event.preventDefault(); event.stopPropagation(); setOpen(false); trigger.current?.focus();
    }
  }}>
    <button type="button" className={`${triggerClassName} eop-actionsTrigger`} ref={trigger}
      aria-expanded={open} aria-controls={panelId} disabled={disabled}
      onClick={() => setOpen((previous) => !previous)}>
      {label}<FiChevronDown aria-hidden="true" />
    </button>
    {open && <div id={panelId} className="eop-actionsPanel" role="region" aria-label={label}>
      {groups.filter((group) => group.actions.length).map((group) => <div key={group.label}
        className={`eop-actionsGroup${group.danger ? " eop-actionsGroup--danger" : ""}`}
        role="group" aria-label={group.label}>
        <span className="eop-actionsGroupLabel">{group.label}</span>
        {group.actions.map(({ label: actionLabel, icon: Icon, onClick, disabled: actionDisabled }) => <button
          key={actionLabel} type="button" className="eop-actionOption" disabled={actionDisabled}
          onClick={() => { setOpen(false); trigger.current?.focus(); onClick(); }}>
          {Icon && <Icon aria-hidden="true" />}<span>{actionLabel}</span>
        </button>)}
      </div>)}
    </div>}
  </div>;
}
